import { render, staticRenderFns } from "./AppArgentinaPoligonos.vue?vue&type=template&id=24dfbbda&lang=pug"
import script from "./AppArgentinaPoligonos.vue?vue&type=script&lang=js"
export * from "./AppArgentinaPoligonos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports